import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Skeleton } from "@/components/ui/skeleton";
import { getInitials } from "@/lib/text-utils";

export type MemberPreviewItem = Readonly<{
  id: string;
  type: "member" | "pending";
  name: string;
  email?: string;
  photoURL?: string;
}>;

export type MembersPreviewProps = Readonly<{
  items: MemberPreviewItem[];
  remaining: number;
  total: number;
  isLoading: boolean;
}>;

export const MembersPreview = ({ items, remaining, total, isLoading }: MembersPreviewProps) => {
  if (isLoading) {
    return (
      <div className="flex -space-x-2">
        {[0, 1, 2].map((key) => (
          <Skeleton key={key} className="h-7 w-7 rounded-full" />
        ))}
      </div>
    );
  }

  if (total === 0) {
    return (
      <div className="flex -space-x-2">
        <Avatar className="h-7 w-7 border-2 border-background bg-muted">
          <AvatarFallback className="text-xs font-medium text-muted-foreground">+</AvatarFallback>
        </Avatar>
      </div>
    );
  }

  return (
    <div className="flex -space-x-2">
      {items.map((item) => (
        <Avatar
          key={item.id}
          className={`h-7 w-7 border-2 border-background ${item.type === "pending" ? "bg-muted" : "bg-background"}`}
        >
          {item.photoURL ? (
            <AvatarImage src={item.photoURL} alt={item.name} />
          ) : (
            <AvatarFallback className={`text-xs font-medium ${item.type === "pending" ? "text-muted-foreground" : "text-foreground"}`}>
              {getInitials(item.name || item.email)}
            </AvatarFallback>
          )}
        </Avatar>
      ))}
      {remaining > 0 ? (
        <Avatar className="h-7 w-7 border-2 border-background bg-muted">
          <AvatarFallback className="text-xs font-medium text-muted-foreground">...</AvatarFallback>
        </Avatar>
      ) : null}
    </div>
  );
};

